import React, { useEffect, useState } from 'react';
import { Button, Input } from "@material-tailwind/react";
import CustomInput from '../../components/CustomInput';
import { CloseButton, PrimaryButton } from '../../components/Buttons';

function PreAccountEditModal({ open, onClose, user, onSave }) {
    const [editedUser, setEditedUser] = useState({});  // Initialize with an empty object

    useEffect(() => {
        if (user) {
            setEditedUser({ ...user });  // Set the state ONLY when user is available
        }
    }, [user]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedUser({ ...editedUser, [name]: value });
  };

  const handleSave = () => {
    onSave(editedUser);
    onClose();
  };

  if (!user) {
    return null;  // Or display a loading state or error message
  }

  if (!open) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex justify-center items-center z-50">
      <div className="relative p-5 border w-full max-w-md bg-white shadow-lg rounded-md">
        <h3 className="text-lg font-semibold mb-4">Edit Lead Details</h3>
        <CloseButton onClick={onClose} className="absolute top-2 right-2" />
        {/* Editable Fields */}
        <div className="mb-4">
          <CustomInput
            label="First Name"
            name="firstName"
            value={editedUser.firstName || ''}
            onChange={handleInputChange}
            color="green"
          />
        </div>
        <div className="mb-4">
          <CustomInput
            label="Last Name"
            name="lastName"
            value={editedUser.lastName || ''}
            onChange={handleInputChange}
            color="green"
          />
        </div>
        <div className="mb-4">
          <CustomInput
            label="Mobile No (WhatsApp)"
            name="mobileNoWa"
            value={editedUser.mobileNoWa || ''}
            onChange={handleInputChange}
            color="green"
          />
        </div>
        <div className="mb-4">
          <CustomInput
            label="Mobile No (Call)"
            name="mobileNoCalling"
            value={editedUser.mobileNoCalling || ''}
            onChange={handleInputChange}
            color="green"
          />
        </div>
        <div className="mb-4">
          <CustomInput
            label="Email"
            name="emailId"
            value={editedUser.emailId || ''}
            onChange={handleInputChange}
            color="green"
          />
        </div>

        <div className="text-right">
         
          <PrimaryButton  onClick={handleSave}>
            Save
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
}

export default PreAccountEditModal;